import { MouseEventHandler } from "react";

interface IProps {
  className?: string;
  onClick?: MouseEventHandler;
  size?: string;
  stroke?: string;
}

export default function EditIcon(props: IProps): JSX.Element {
  // stroke : #7A7A7A
  return (
    <svg
      className={`h-full w-full ${props.className}`}
      fill="none"
      onClick={props.onClick ? props.onClick : undefined}
      stroke={props.stroke || 'currentcolor'}
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.5 4H4.5C3.96957 4 3.46086 4.21071 3.08579 4.58579C2.71071 4.96086 2.5 5.46957 2.5 6V20C2.5 20.5304 2.71071 21.0391 3.08579 21.4142C3.46086 21.7893 3.96957 22 4.5 22H18.5C19.0304 22 19.5391 21.7893 19.9142 21.4142C20.2893 21.0391 20.5 20.5304 20.5 20V13"
      />
      <path
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19 2.5C19.3978 2.10217 19.9374 1.87868 20.5 1.87868C21.0626 1.87868 21.6022 2.10217 22 2.5C22.3978 2.89782 22.6213 3.43739 22.6213 4C22.6213 4.56261 22.3978 5.10217 22 5.5L12.5 15L8.5 16L9.5 12L19 2.5Z"
      />
    </svg>
  );
}
